export enum ListItemState {
  Changed = 'changed',
  Added = 'added',
  Deleted = 'deleted',
}
